'use strict';
var OptimizingClinicalOperationsController = /** @class */ (function () {
    /*@ngInject*/
    function OptimizingClinicalOperationsController($scope, EducationSubNavService) {
        this.headerContent = "As an individual practitioner, much of the responsibility for building a successful business falls directly on your shoulders. While you may have a clear vision of how you will help patients clinically, practice success requires you to also anchor that vision by mastering the key systems for running your daily business operations. View our resources to learn how to create your practice playbook and build a successful practice from the inside out.";
        $scope.$ctrl.value.selectedpageindex = 1;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
    }
    return OptimizingClinicalOperationsController;
}());
export default OptimizingClinicalOperationsController;
//# sourceMappingURL=optimizing-clinical-operations.controller.js.map